class Settings {
    constructor() {
        this.twoFactorEnabled = false;
        this.theme = 'light';
        this.fontSize = 'medium';
        this.showSFW = true;
        this.showNSFW = false;
        this.showNSFWPlus = false;
        this.showGore = false;
        this.isAdult = false;
        this.flash = true;
        this.onboarded = true;
        this.followed = false;
    }

    static fromAPI(data) {
        const NEWSETTINGS = new Settings();

        if (!data) return NEWSETTINGS;
        
        NEWSETTINGS.twoFactorEnabled = data.twoFactorEnabled;
        NEWSETTINGS.theme = data.theme;
        NEWSETTINGS.fontSize = data.fontSize;
        NEWSETTINGS.showSFW = data.showSFW !== undefined ? data.showSFW : true;
        NEWSETTINGS.showNSFW = data.showNSFW || false;
        NEWSETTINGS.showNSFWPlus = data.showNSFWPlus || false;
        NEWSETTINGS.showGore = data.showGore || false;
        NEWSETTINGS.isAdult = data.isAdult || false;
        NEWSETTINGS.flash = data.flash;
        NEWSETTINGS.onboarded = data.onboarded;
        NEWSETTINGS.followed = data.followed;

        return NEWSETTINGS;
    }

    toJSON() {
        return {
            twoFactorEnabled: this.twoFactorEnabled,
            theme: this.theme,
            fontSize: this.fontSize,
            showSFW: this.showSFW,
            showNSFW: this.showNSFW,
            showNSFWPlus: this.showNSFWPlus,
            showGore: this.showGore,
            isAdult: this.isAdult,
            flash: this.flash,
            onboarded: this.onboarded,
            followed: this.followed,
        }
    }
}

export default Settings;
